import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import i18next from 'i18next';

import TitleLogo from 'components/TitleLogo';
// Temporarily leaving this stylesheet to handle grid only styles
// until different solution for grid is implemented.
import styles from './styles.module.scss';

export default function TitleAndDescription({
  title = i18next.t('Latest Video'),
  logoUrl,
  description,
  vertical,
  isLeadPackageAdjacent,
}) {
  const containerClasses = classNames(
    styles.titleAndDescCont,
    'video-package__title-and-desc--container',
    'self-stretch self-end-m df flex-column justify-center pa7 pv6-m ph8-m pv7-xl',
  );

  const titleClasses = classNames(
    'video-package__title-and-desc--heading',
    'ma0 f7 f8-m lh-none ls-normal font-title',
    {
      'video-package__title-and-desc--title-with-line': vertical === 'today' && !isLeadPackageAdjacent,
    },
  );
  return (
    <div
      className={containerClasses}
    >
      <h2
        className={titleClasses}
      >
        <TitleLogo logoUrl={logoUrl} title={title} />
      </h2>
      {description && (
        <p className="video-package__title-and-description--info f3">
          {description}
        </p>
      )}
    </div>
  );
}

TitleAndDescription.propTypes = {
  description: PropTypes.string,
  isLeadPackageAdjacent: PropTypes.bool,
  logoUrl: PropTypes.string,
  title: PropTypes.string,
  vertical: PropTypes.string,
};

TitleAndDescription.defaultProps = {
  description: null,
  isLeadPackageAdjacent: false,
  logoUrl: null,
  title: null,
  vertical: null,
};
